import { categories } from "keys"

const multipleChoiceQuestions = {
    'NO_NIKUD': {
        title: "שאלה לדוגמא",
        questions:

            [
                {
                    text: "שאלה על הסיפור",
                    answers: [
                        {
                            text: "תשובה מספר 1"
                        },
                        {
                            text: "תשובה מספר 2"
                        },
                        {
                            text: "תשובה מספר 3"
                        }
                    ]
                }
            ]
    },
    'NIKUD': {
        title: "שְׁאֵלָה לְדֻגְמָא",
        questions:
            [
                {
                    text: "שְׁאֵלָה עַל מָה שֶׁהָיָה כָּתוּב",
                    answers: [
                        {
                            text: "תְּשׁוּבָה רִאשׁוֹנָה"
                        },
                        {
                            text: "תְּשׁוּבָה שְׁנִיָּה"
                        },
                        {
                            text: "תְּשׁוּבָה שְׁלִישִׁית"
                        }
                    ]
                }
            ]
    }
}

export default multipleChoiceQuestions